import React from "react";
import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";
import "firebase/storage";
import profile from "../../../../assets/images/profile.png";
import firebaseManager from "../../../../model/Firebase/FirebaseManager";

var storage = firebase.storage();

class PhotoProfile extends React.Component {
  constructor() {
    super();
    this.handleChange = this.handleChange.bind(this);
    this.state = {
      image: null,
      url: "",
      uploadValue: 0,
    };
    this.getDentuser();
  }

  getDentuser() {
    firebaseManager.getInfoForCurrentTechnician(this.getUsersCallback);
  }

  getUsersCallback = (userProfileData) => {
    this.setState({
      url: userProfileData.photoProfile,
    });
  };
  handleChange(e) {
    this.setState({
      [e.target.name]: e.target.value,
    });
  }

  handleUpload = (e) => {
    const file = e.target.files[0];
    const storageRef = firebase.storage().ref(`images/${file.name}`);
    const task = storageRef.put(file);

    task.on(
      "state_changed",
      (snapshot) => {
        // progrss function ....
        let percentage =
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        this.setState({
          uploadValue: percentage,
        });
        if (percentage === 100) {
          document.getElementById("progress").classList.add("d-none");
        }
      },
      (error) => {
        // error function ....
        console.log(error);
      },
      () => {
        // complete function ....
        storage
          .ref("images")
          .child(file.name)
          .getDownloadURL()
          .then((url) => {
            this.setState({ url });
            firebase.auth().onAuthStateChanged(function (user) {
              if (user) {
                let currentUserCollection = firebase
                  .firestore()
                  .collection("users")
                  .doc(user.uid);

                return currentUserCollection
                  .update({
                    photoProfile: url,
                  })
                  .then(function () {
                    window.location.reload();
                  })
                  .catch(function (error) {
                    alert(error);
                  });
              }
            });
            localStorage.setItem("photoProfile", url);
          });
      }
    );
  };
  render() {
    return (
      <div className="container">
        <form>
          <input
            type="file"
            id="photoProfile"
            className="SubirFoto"
            accept="image/png, .jpeg, .jpg"
            onChange={this.handleUpload}
          />
          <label htmlFor="photoProfile">
            <img
              src={this.state.url || profile}
              className="rounded-circle img-fluid mb-2"
              width="110"
              height="100"
              alt="Uploaded images"
            />
          </label>
          <progress
            id="progress"
            className="mt-1"
            value={this.state.uploadValue}
            max="100"
          ></progress>
        </form>
        <p> Touch to change photo </p>
      </div>
    );
  }
}
export default PhotoProfile;
